import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchLogs } from '../../../../actions/log/logList'
import Logs from '../../Logs'
import { AppState } from '../../../../reducers'
import { Filters, FiltersBar, FilterSelector, FilterTextField } from '../../../Utils/Filters/Filter'
import { personTypeToDescription, visiblePersonTypes } from '../../../Client/Profile'
import { LogListState } from '../../../../reducers/log/logList'
import { useTranslation } from 'react-i18next'
import { isHeadSales, isManager, SessionState } from '../../../../reducers/auth/session'
import moment from 'moment'
import { FilterFromDate, FilterToDate } from '../../../Utils/Filters'
import { getToken } from '../../../../utils/fetchApi'
import { Button, Stack } from '@mui/material'
import { FiletypeXls } from 'react-bootstrap-icons'

interface Props {
  fullInfo?: boolean
  logList: LogListState
  session: SessionState
}

const LogList: React.FC<Props> = ({ logList, session }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['log', 'person'])

  useEffect(() => {
    dispatch(fetchLogs(history.location.search))
  }, [dispatch, history.location.search])


  const linkToLogData = (id: number) => {
    /*
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/logs/${id}`
    history.push(detailUrl)
    */
  }

  const translatePersonTypeDescription = (value: string): string => t(personTypeToDescription(value), { ns: 'person' })


  const initLogDefaultFilters: Filters = {
    dateFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    dateTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
  }

  const DownloadButton = () => {
    const handleDownloadAndShare = async () => {
      /*
       * history.location.search ya contiene el signo ?.
       * URLSearchParams evita generar ??dateFrom.
       */
      const queryParams = new URLSearchParams(history.location.search)

      const token = getToken() || ''

      queryParams.set('access_token', token)

      const url =
        `${process.env.REACT_APP_API_URL}/DLLog?${queryParams.toString()}`

      try {
        const response = await fetch(url)

        if (!response.ok) {
          let message = 'No se pudo generar el archivo de usabilidad.'

          try {
            const errorData = await response.json()

            if (errorData?.error) {
              message = errorData.error
            }
          } catch {
            // La respuesta podría no ser JSON.
          }

          window.alert(message)
          return
        }

        const blob = await response.blob()

        const contentDisposition =
          response.headers.get('Content-Disposition')

        const fileNameMatch =
          contentDisposition?.match(/filename="?([^"]+)"?/i)

        const fileName = fileNameMatch
          ? fileNameMatch[1]          
          : `industrias-saladillo-usabilidad-${moment()
            .tz('America/Argentina/Buenos_Aires')
            .format('YYYY-MM-DD')}.xlsx`

        const file = new File(
          [blob],
          fileName,
          {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        )

        if (
          navigator.share &&
          navigator.canShare?.({ files: [file] })
        ) {
          await navigator.share({
            files: [file],
            title: t('download', { ns: 'others' }),
            text:
              t('shareText', { ns: 'others' }) ||
              'Compartir usabilidad'
          })

          return
        }

        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.href = downloadUrl
        link.download = fileName

        document.body.appendChild(link)
        link.click()
        link.remove()

        window.URL.revokeObjectURL(downloadUrl)
      } catch (error) {
        console.error('Error al descargar/compartir:', error)

        window.alert(
          'Ocurrió un error al generar o descargar el archivo de usabilidad.'
        )
      }
    }

    return (
      <Stack
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        padding="10px"
        paddingTop="20px"
      >
        <Button
          id="download"
          aria-label="download"
          size="large"
          style={{ textTransform: 'none' }}
          onClick={handleDownloadAndShare}
        >
          {t('download')}&nbsp;&nbsp;
          <FiletypeXls size={30} />
        </Button>
      </Stack>
    )
  }

  const filterVisiblePersonTypes = visiblePersonTypes.filter(pt => isHeadSales(session) ? pt !== 'A' && pt !== 'M' : isManager(session) ? pt !== 'A' : true)

  return (
    <div>
      <FiltersBar defaultFilters={initLogDefaultFilters}>
        <FilterFromDate name="dateFrom" />
        <FilterToDate name="dateTo" />
        <FilterTextField name="fullName" label={t("name")} />
        <FilterSelector name="personType" menuItems={filterVisiblePersonTypes} textAdapter={translatePersonTypeDescription} label={t('personType', { ns: 'person' })} />
        <FilterTextField name="byPersonTypeId" label={t("byPersonTypeId")} />

        {/*<FilterTextField style={{ width: '350px', maxWidth: '350px' }} name="action" label={t("action")} />*/}
      </FiltersBar>
      <Logs
        rows={(logList.logs || []).map(s => ({ data: s }))}
        loading={logList.isFetching}
        pagination={logList.pagination || undefined}
        onClickInfo={linkToLogData}
      />
      {<DownloadButton />}

    </div>
  )
}



const mapStateToProps = (state: AppState) => ({
  logList: state.logList,
  session: state.session
})

export default connect(mapStateToProps, null)(LogList)